import { analyzeAndValidateNgModules } from '@angular/compiler';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Menus } from 'app/shared/constants/menu.constant';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { ExportDataService } from 'app/shared/service/export.service';
import { NavigateRightService } from 'app/shared/service/navigate-rights.service';
import { SharedService } from 'app/shared/service/shared.service';
import { ToasterService } from 'app/shared/service/toaster.service';
import { cloneDeep } from 'lodash';
import { ConfirmationService } from 'primeng/api';
import { CreateOrUpdateDocumentVaultDto } from 'shared/service-proxies/models/create-or-update-document-vault-dto.model';
import { DocumentVaultDtos } from 'shared/service-proxies/models/document-vault-dtos.model';
import { DesignationServiceProxy } from 'shared/service-proxies/services/designation.service';
import { DocumentVaultServiceProxy } from 'shared/service-proxies/services/document-vault.service';
import { DesignationDto } from '../../../../nswag/service.extensions';
// import {saveAs} from 'file-saver';
import { saveAs } from 'file-saver'
import { type } from 'os';
@Component({
  selector: 'app-document-vault-master',
  templateUrl: './document-vault-master.component.html',
  styleUrls: ['./document-vault-master.component.scss']
})
export class DocumentVaultMasterComponent implements OnInit {
  documentDialog: boolean;
  document?: CreateOrUpdateDocumentVaultDto;
  documents?: DocumentVaultDtos[];
  total: number = 0;
  submitted: boolean;
  menuAccess: any
  designationsName: any[];
  designationName: any;
  uploadedFiles: any[] = [];
  companyID: any;
  exportList: DocumentVaultDtos[] = [];
  documentBase: any;
  isValidDocument: boolean = false;
  choosenImage: any = null;
  imageBase: string = '';
  image: any;
  displayBasic2: boolean;
  images: any;
  preview_image: any;
  isAdmin = false;
  isUser: boolean;

  @ViewChild('documentPath') documentPath: any
  @ViewChild('FileSelectInputDialog') FileSelectInputDialog: ElementRef;


  constructor(
    private _documentVaultService: DocumentVaultServiceProxy,
    private _designationServicProxy: DesignationServiceProxy,
    private confirmationService: ConfirmationService,
    private _navigateRightsService: NavigateRightService,
    private toasterService: ToasterService,
    private _sharedService: SharedService,
    private _exportDataService: ExportDataService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _authenticationService: AuthenticationService,
  ) {

    this.isAdmin = this._authenticationService.isAdministrator();

  }
  ngOnInit(): void {
    this.getMenuAccess();
    this.getAllDocument();
    this.getDocumentType();
    this.companyID = this._sharedService.selectedAllCompany;
  }

  getMenuAccess() {
    this.menuAccess = this._navigateRightsService.menuRights(Menus.DOCUMENT_VAULT);
  }
  openNew() {
    this.document = new CreateOrUpdateDocumentVaultDto();
    this.document.isActive = true;
    this.submitted = false;
    this.documentDialog = true;
    this.imageBase = null;
  }

  getAllDocument() {
    if (this.isAdmin) {
      this._documentVaultService.getAllDocumentsVault().subscribe(response => {
        if (response.isSuccess) {
          this.documents = response.responseData;
          this.total = this.documents.length;
        }
        else {
          this.toasterService.showApiValidation(response);
        }
      });
    }
    else {
      this._documentVaultService.getActiveDocumentsVault().subscribe(response => {
        if (response.isSuccess) {
          this.documents = response.responseData;
          this.total = this.documents.length;
        }
        else {
          this.toasterService.showApiValidation(response);
        }
      });
    }
  }
  onFilter(data) {
    this.total = data.filteredValue.length;
  }
  editDocument(document: DocumentVaultDtos) {
    this.document = JSON.parse(JSON.stringify(document));
    this.imageBase = '';
    this.submitted = true;
    this.documentDialog = true;
  }
  getDocumentType() {
    this._designationServicProxy.getActiveDesignation().subscribe(response => {
      if (response.isSuccess)
        this.designationsName = [];
      this.designationsName.push({ id: null, designationName: 'All' });
      this.designationsName = this.designationsName.concat(response.responseData);
      //  this.designationsName= response.responseData;
      this._changeDetectorRef.detectChanges();
    });
  }

  downloadDocument(image) {
    window.open(image, "_blank");
    var images = image;
  }

  showBasicDialog2(documentPath) {
    this.preview_image = documentPath;
    this.displayBasic2 = true;
  }

  AppendSRC() {
    var Iframe = document.getElementById("frame");
    Iframe.setAttribute("src", this.preview_image);

  }

  renderImage($event: any) {
    if ($event.target.files && $event.target.files.length > 0) {
      this.choosenImage = $event.target.files[0].name;
      var docFile = this.choosenImage;
      // this.document.documentType = this.choosenImage.split('.')[0];

      var FileArry = $event.target.files[0].name.split(".");
      this.document.documentType = '.' + FileArry[FileArry.length - 1];

      var reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageBase = e.target.result;
      };
      // you have to declare the file loading

      reader.readAsDataURL($event.target.files[0]);
    }

  }

  downloadImg(preview_image) {
    saveAs(preview_image);
    // window.open =  preview_image
  }

  saveDocument() {
    this.submitted = true;
    if (this.imageBase) {
      this.document.documentUri = this.imageBase.split(",")[1];
    }

    if (this.document.documentName && (this.document.designationId || this.document.designationId == null) && (this.document.id || this.document.documentUri)) {

      this._documentVaultService.createOrUpdateDocumentsVault(this.document).subscribe(response => {

        if (response.isSuccess) {
          this.document.id ? this.toasterService.toastSuccess('Successful', 'Designation Vault Updated') : this.toasterService.toastSuccess('Successful', 'Designation Vault Save Successfully');

          this.document = new CreateOrUpdateDocumentVaultDto
          this.documentDialog = false;
          this.getAllDocument()
        }
        else {
          this.toasterService.showApiValidation(response);
        }
      })
    }
    // this.saveDocument();
  }

  deleteDocument(document: DocumentVaultDtos) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' + document.documentName + ' Document Vault ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._documentVaultService.deleteDocumentsVaultById(document.id).subscribe(response => {
          if (response.isSuccess) {
            this.getAllDocument();
            // this.document = new CreateOrUpdateDocumentVaultDto();
            // this.documents = this.documents.filter(x => x.id !== document.id);
            this.toasterService.toastSuccess('Successful', 'Document Vault Deleted');
          }
          else {
            this.toasterService.showApiValidation(response);
          }
        });
      }
    });

  }

  UploadImage() {
    var InputBox = document.getElementById("documentPath")
    InputBox.click();
  }

  hideDialog() {
    this.documentDialog = false;
    this.submitted = false;
  }
  hideDialogFile() {
    this.displayBasic2 = false;
  }

  ExportExcel() {
    this.exportList = [];
    this.exportList = this.documents.map(x => {
      return {
        "Company Name": x.company.companyName,
        "Designation": x.designation?.designationName || 'All',
        "Document Name": x.documentName,
        "Document File Path": x.documentPath,
        "Status": x.isActive ? 'Active' : 'inActive'
      }
    }) as any;
    this._exportDataService.exportExcel(this.exportList, "Document Vault Master");
  }
}

